import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsPage() {
    return (
        <div className="min-h-screen bg-obsidian-300 text-white">
            {/* Header */}
            <div className="fixed top-0 left-0 right-0 z-50 px-6 py-4 bg-obsidian-300/80 backdrop-blur-sm border-b border-white/5">
                <div className="max-w-4xl mx-auto flex items-center gap-4">
                    <Link
                        to="/"
                        className="flex items-center gap-2 text-zinc-400 hover:text-gold-400 transition-colors"
                    >
                        <ArrowLeft className="w-5 h-5" />
                        Back
                    </Link>
                    <span className="font-secondary font-bold text-sm tracking-[0.3em] uppercase text-gold-400">
                        StackVibecode
                    </span>
                </div>
            </div>

            {/* Content */}
            <main className="max-w-4xl mx-auto px-6 py-24">
                <article className="prose prose-invert prose-zinc max-w-none">
                    <h1 className="font-secondary font-bold text-3xl md:text-4xl text-white mb-8">
                        Terms and Conditions
                    </h1>

                    <p className="text-zinc-400 mb-8">
                        <strong>Last Updated:</strong> January 27, 2026
                    </p>

                    <p className="text-zinc-300 mb-6">
                        Welcome to StackVibecode! These Terms and Conditions govern your use of our website and services. By accessing or using the Service, you agree to be bound by these Terms.
                    </p>

                    <h2 className="font-semibold text-xl text-white mt-8 mb-4">1. Description of Service</h2>
                    <p className="text-zinc-300 mb-6">
                        StackVibecode is an AI-powered platform designed to assist developers and entrepreneurs in analyzing app ideas, generating tech stacks, and providing market research data. The Service uses Artificial Intelligence (AI) to generate content and recommendations.
                    </p>

                    <h2 className="font-semibold text-xl text-white mt-8 mb-4">2. Accounts</h2>
                    <ul className="text-zinc-300 mb-6 list-disc list-inside space-y-2">
                        <li><strong>Registration:</strong> You must register for an account to access certain features. You agree to provide accurate and complete information during registration.</li>
                        <li><strong>Authentication:</strong> Authentication is managed by Clerk. You are responsible for maintaining the confidentiality of your account.</li>
                        <li><strong>Responsibility:</strong> You are fully responsible for all activities that occur under your account.</li>
                    </ul>

                    <h2 className="font-semibold text-xl text-white mt-8 mb-4">3. Subscriptions and Payments</h2>
                    <ul className="text-zinc-300 mb-6 list-disc list-inside space-y-2">
                        <li><strong>Payment Gateway:</strong> We use Whop.com as our payment processor. By subscribing, you agree to Whop's Terms of Service.</li>
                        <li><strong>Billing:</strong> Subscriptions are billed on a recurring basis as selected at checkout.</li>
                        <li><strong>Cancellation:</strong> You may cancel your subscription at any time. Access continues until the end of the billing period.</li>
                        <li><strong>Refunds:</strong> Refund requests are handled in accordance with Whop's refund policy.</li>
                    </ul>

                    <h2 className="font-semibold text-xl text-white mt-8 mb-4">4. AI-Generated Content</h2>
                    <ul className="text-zinc-300 mb-6 list-disc list-inside space-y-2">
                        <li><strong>Nature of AI:</strong> Output is generated by AI models which can sometimes make errors or provide inaccurate information.</li>
                        <li><strong>No Professional Advice:</strong> The Service is for informational purposes only. Verify all recommendations independently.</li>
                        <li><strong>Ownership:</strong> You own the inputs you provide and the outputs generated for your account.</li>
                    </ul>

                    <h2 className="font-semibold text-xl text-white mt-8 mb-4">5. User Conduct</h2>
                    <p className="text-zinc-300 mb-4">You agree not to use the Service:</p>
                    <ul className="text-zinc-300 mb-6 list-disc list-inside space-y-2">
                        <li>To generate content that is illegal, harmful, or threatening</li>
                        <li>To reverse engineer or decompile the Service</li>
                        <li>To build a competing product</li>
                        <li>To exceed usage limits intentionally</li>
                    </ul>

                    <h2 className="font-semibold text-xl text-white mt-8 mb-4">6. Limitation of Liability</h2>
                    <p className="text-zinc-300 mb-6">
                        In no event shall StackVibecode be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the Service.
                    </p>

                    <h2 className="font-semibold text-xl text-white mt-8 mb-4">7. Changes to Terms</h2>
                    <p className="text-zinc-300 mb-6">
                        We reserve the right to modify these Terms at any time. We will provide notice prior to any significant changes.
                    </p>

                    <h2 className="font-semibold text-xl text-white mt-8 mb-4">8. Contact Us</h2>
                    <p className="text-zinc-300 mb-6">
                        If you have any questions about these Terms, please contact us.
                    </p>
                </article>
            </main>
        </div>
    );
}
